import { createReducer } from "reduxsauce"
import { takeLatest, select, put } from "redux-saga/effects"
import actionCreator from "helpers/actionCreator"
import { Types as BaseTypes } from "modules/portfolio-root/model"
import { getCategoryItemsSubset } from "./selectors/data"

export const { Types, Creators } = actionCreator("ompnt/modules/analyzeRisk", {
  toggle: {
    props: ["id", "currentState", "showSegment"],
    track: true,
    trackType: "analyze-risk-graph-legend-factor",
    trackPayload: ({ id, currentState }) => ({ factor: id, state: currentState ? "on" : "off" }),
  },
  focusChartLine: ["focusedChartLine"],
  blurChartLine: [],
  setDisplayType: {
    props: ["displayType"],
    track: true,
    trackType: "analyze-risk-category-selection",
    trackPayload: ({ displayType }) => ({ type: displayType }),
  },
  trackCSVDownload: {
    track: true,
    trackType: "analyze-risk-graph-timeseries-download",
  },
  toggleOnly: {
    props: ["id", "state", "showSegment"],
    track: true,
    trackType: "analyze-risk-graph-legend-factor",
    trackPayload: ({ id, state }) => ({ factor: id, state }),
  },
  toggleOnlySuccess: ["selected", "only", "items", "showSegment"],
})

const DEFAULT_STATE = {
  displayType: "total",
  focusedChartLine: null,
  disabled: {},
  only: null,
}

function handleSetDisplayType(state, { displayType }) {
  const newState = { displayType, only: null }

  if (displayType !== "total" && displayType !== "factors" && state.disabled[`${displayType}_total`] === undefined) {
    newState.disabled = { ...state.disabled, [`${displayType}_total`]: true }
  }

  return { ...state, ...newState }
}

function handleToggle(state, { id, showSegment }) {
  let disabled
  let focusedChartLine

  if (state.disabled[id]) {
    focusedChartLine = id

    if (!showSegment && (id === "specific" || id === "factor")) {
      disabled = { ...state.disabled, specific: false, factor: false }
    } else {
      disabled = { ...state.disabled, [id]: false }
    }
  } else {
    focusedChartLine = null

    if (!showSegment && (id === "specific" || id === "factor")) {
      disabled = { ...state.disabled, specific: true, factor: true }
    } else {
      disabled = { ...state.disabled, [id]: true }
    }
  }
  return { ...state, disabled, focusedChartLine, only: null }
}

function handleFocusChartLine(state, { focusedChartLine }) {
  return { ...state, focusedChartLine }
}

function handleBlurChartLine(state) {
  return { ...state, focusedChartLine: null }
}

function handleToggleOnlySuccess(state, { selected, only, items, showSegment }) {
  const disabled = {}
  let focusedChartLine = null
  let onlyDisplay = null

  if (only) {
    focusedChartLine = selected
    onlyDisplay = selected

    if (!showSegment && (selected === "specific" || selected === "factor")) {
      items.forEach(item => {
        if (item.id !== selected && item.id !== "specific" && item.id !== "factor") {
          disabled[item.id] = true
        }
      })
    } else {
      items.forEach(item => {
        if (item.id !== selected) {
          disabled[item.id] = true
        }
      })
    }
  }

  return { ...state, disabled, focusedChartLine, only: onlyDisplay }
}

function handleSetModel(state) {
  return { ...state, only: null, focusedChartLine: null }
}

export default createReducer(DEFAULT_STATE, {
  [Types.TOGGLE]: handleToggle,
  [Types.FOCUS_CHART_LINE]: handleFocusChartLine,
  [Types.BLUR_CHART_LINE]: handleBlurChartLine,
  [Types.SET_DISPLAY_TYPE]: handleSetDisplayType,
  [Types.TOGGLE_ONLY_SUCCESS]: handleToggleOnlySuccess,
  [BaseTypes.SET_MODEL]: handleSetModel,
})

function* handleToggleOnly({ id, showSegment }) {
  const { items, only } = yield select(state => ({
    items: getCategoryItemsSubset(state),
    only: state.modules.analyzeRisk.only,
  }))

  yield put(Creators.toggleOnlySuccess(id, only !== id, items, showSegment))
}

export function* saga() {
  yield takeLatest(Types.TOGGLE_ONLY, handleToggleOnly)
}
